import { useTranslation } from "react-i18next";
import { ImageCropModal } from "../../../components/imageUpload/ImageCropModal";

interface AvatarCropModalProps {
  file: File | null;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (file: File) => void;
}

export function AvatarCropModal({
  file,
  isOpen,
  onClose,
  onConfirm,
}: AvatarCropModalProps) {
  const [t] = useTranslation();
  return (
    <ImageCropModal
      file={file}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={(cropped) => onConfirm(cropped)}
      aspect={1}
      cropShape="round"
      title={t("screens.settings.cropAvatar")}
      confirmLabel={t("screens.settings.upload")}
      cancelLabel={t("screens.settings.cancel")}
    />
  );
}
